import { LoadingButton } from '@mui/lab';
import { Button, DialogActions, DialogContent, Divider, Stack, Typography } from '@mui/material';
import toast from 'react-hot-toast';

import { DEFAULT_ERROR_MESSAGE } from '@/constants/app/config';
import { useEditRestockMutation } from '@/store/api/services/restocking/restocking';
import { RestockRequestStatus } from '@/types/generated/boro';

import type { ModalChildrenProps } from '@bitstopco/bitstop-theme';

const CancelLoadOrder = ({ props, hide }: ModalChildrenProps) => {
  const id = props?.id;
  const [editRestock, { isLoading }] = useEditRestockMutation();

  const handleSubmit = async () => {
    try {
      await editRestock({ id, data: { status: RestockRequestStatus.Cancelled } }).unwrap();
      hide();
      toast.success('Load Order canceled successfully');
    } catch (error) {
      toast.error((error as any).message ?? DEFAULT_ERROR_MESSAGE);
    }
  };

  return (
    <>
      <DialogContent>
        <Stack gap={2} py={3}>
          <Typography>Once this action is performed, it cannot be undone.</Typography>
          <Typography>Are you sure you want to cancel this order?</Typography>
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button onClick={hide}>Cancel</Button>
        <LoadingButton color="error" loading={isLoading} onClick={handleSubmit} variant="contained">
          Confirm
        </LoadingButton>
      </DialogActions>
    </>
  );
};

export default CancelLoadOrder;
